import React, {useState, useEffect} from 'react'
import './ExtendedContentSubpage.scss'
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import AllExpertCornerQuery from "../../queries/AllExpertCornerQuery";
import Loading from "../../component/Loading";

import AllNewsQuery from "../../queries/AllNewsQuery";
import NewsList from "../../component/NewsList/NewsList";
import {MDBBox} from "mdbreact";
import {getFormattedDate} from '../../util'
import {Fade} from "react-reveal";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";

const expert = assetUrl + 'images/expert-corner-sample1.png'
const expert1 = assetUrl + 'images/expert-corner-sample2.png'

const ExtendedContentSubpage = (props) => {
	const [pageName, setPageName] = useState("");
	const [dataList, setDataList] = useState([])
	const [loading, setLoading] = useState(0);

	useEffect(() => {
		props.match.params.action === "news" ?
			setPageName("News") : setPageName("Expert Corner")
		props.match.params.action === "news" ? getStockNews() : getAllExpertCorner()

	}, []);

	const updateLoading = (action) => {
		setLoading(action)
	}

	const getStockNews = () => {
		let variables = {
			politician: ""
		}
		updateLoading(true);
		fetchQuery(environment, AllNewsQuery, variables)
			.toPromise()
			.then(response => {
				updateLoading(false);
				if (response.allNews !== null && response.allNews.edges.length > 0) {
					setDataList(response.allNews.edges)
				} else {
					setDataList([])
				}
			}, err => {
				updateLoading(false);
				console.log(err);
				setDataList([])
			});
	}

	const getAllExpertCorner = () => {
		let variables = {}
		updateLoading(true);
		fetchQuery(environment, AllExpertCornerQuery, variables)
			.toPromise()
			.then(response => {

				if (response.allExpertCorner !== null && response.allExpertCorner.edges.length > 0) {
					setDataList(response.allExpertCorner.edges)
				} else {
					setDataList([])
				}
				updateLoading(false);
			}, err => {
				updateLoading(false);
				console.log(err);
				setDataList([])
			});
	}

	return (
		<Loading loading={loading}>
			<div className={"extended-main"}>
				<TopNavSubpage heading={pageName} wallet={props.match.params.action !== "news"} notify={true}
				               border={true}/>
				<div className={"extended-content-area p-4"}>
					{/*<select className={"filter"}>*/}
					{/*	<option>Latest</option>*/}
					{/*	<option>Trending</option>*/}
					{/*</select>*/}
					<div className={"my-3"}>

						{
							props.match.params.action === "news" ?
								<NewsList news_list={dataList}/>
								:
								<ExpertCornerPage data={dataList}
								                  componentLoading={loading}
								                  getFormattedDate={getFormattedDate}/>
						}

					</div>
				</div>
			</div>
		</Loading>
	)
}

export const ExpertCornerPage = (props) => {
	const {data, componentLoading} = props

	return (
		<div className={"expert-corner-page"}>
			{
				componentLoading ?
					<>
						<div className={"d-flex"}>
							<Skeleton width={"150px"} height={"152px"}/>
							<div style={{width:"100%",padding:"10px"}}>
								<Skeleton count={3} width={"100%"}/>
							</div>
						</div>
						<div className={"d-flex"}>
							<Skeleton width={"150px"} height={"152px"}/>
							<div style={{width:"100%",padding:"10px"}}>
								<Skeleton count={3} width={"100%"}/>
							</div>
						</div>
						<div className={"d-flex"}>
							<Skeleton width={"150px"} height={"152px"}/>
							<div style={{width:"100%",padding:"10px"}}>
								<Skeleton count={3} width={"100%"}/>
							</div>
						</div>
					</>
				:
					<Fade bottom>
						{data.length > 0 && data.map((item, index) => {

							return <div className={'d-flex align-items-center mb-4'} key={item.id}>
								<img src={item.node.expertCornerImage} alt={"alt"} className={"image mr-3"}/>
								<a href={item.node.link}>
									{/*<div>*/}
									{

										item.node.tags.length > 0 && <MDBBox className={"tags-list-section pb-2"}>
											<div className="input-tag">
												<ul className="input-tag__tags">
													{item.node.tags.map((item, index) => {
														return <li key={index}
														           className={"party-badge my-0 mr-2 "}>{item}</li>

													})}</ul>
											</div>
										</MDBBox>
									}
									<p className={'heading'}>{item.node.shortDescription}</p>
									<p className={"author"}>{item.node.source}</p>
									<p className={"date mb-0"}>{getFormattedDate(item.node.created)}</p>
									{/*</div>*/}
								</a>
							</div>
						})}
					</Fade>

			}

		</div>
	)
}

// export const NewsListPage = (props) => {
// 	return (
// 		<div>
//
// 		</div>
// 	)
// }

export default ExtendedContentSubpage

